// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__62M-6","loading":"styles_loading__9eV5T","round":"styles_round__LdTbV"};